import * as React from "react";

function SvgTablet(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M13 14.8H3c-.4 0-.8-.3-.8-.8V2c0-.4.3-.8.8-.8h10c.4 0 .8.3.8.8v12c0 .4-.4.8-.8.8zm-9.2-2.6h8.5V2.8H3.8v9.4z" /></svg>;
}

export default SvgTablet;